import { useState, useCallback } from 'react'

/**
 * Manages MFA-related state: pending challenge, setup requirement, and method.
 * Extracted from AuthContext for single-responsibility.
 */
export function useMfaState() {
  const [mfaPending, setMfaPending] = useState(false)
  const [mfaSetupNeeded, setMfaSetupNeeded] = useState(false)
  const [mfaMethod, setMfaMethod] = useState(null)

  /** Apply MFA fields from a session/login response */
  const applyMfaFromSession = useCallback((data) => {
    if (data.mfa_pending) {
      setMfaPending(true)
      setMfaSetupNeeded(data.mfa_setup_needed || false)
      setMfaMethod(data.mfa_method || null)
      return true // indicates MFA challenge is active
    }
    setMfaPending(false)
    setMfaSetupNeeded(false)
    setMfaMethod(data.mfa_method || null)
    return false
  }, [])

  /** Apply MFA fields from a login response that returned mfa_required */
  const applyMfaFromLogin = useCallback((data) => {
    setMfaPending(true)
    setMfaSetupNeeded(data.mfa_setup_needed || false)
    setMfaMethod(data.mfa_method || null)
  }, [])

  /** Reset all MFA state (e.g. on logout) */
  const resetMfa = useCallback(() => {
    setMfaPending(false)
    setMfaSetupNeeded(false)
    setMfaMethod(null)
  }, [])

  return {
    mfaPending,
    mfaSetupNeeded,
    mfaMethod,
    setMfaPending,
    setMfaSetupNeeded,
    setMfaMethod,
    applyMfaFromSession,
    applyMfaFromLogin,
    resetMfa,
  }
}
